import React, { Component } from "react";
import { Fragment } from "react";
import SectionLayout from "../../../utility/ui-components/sectionLayout";
import AboutData from "../../../../common/assets/data/about/about";
import SectionHeading from "../../../utility/ui-components/sectionHeading";


function ContentSection() {
    const data = AboutData
  return (
    <Fragment>
      <SectionLayout content={data.AboutVadiyo} />
      <SectionLayout content={data.LMSVadiyo} />
      <SectionLayout content={data.HMSVadiyo} />
      <SectionLayout content={data.VaidyoContent} />
    </Fragment>
  );
}

export default ContentSection;
